import React, { useState } from 'react';
import FileCopyOutlined from '@mui/icons-material/FileCopyOutlined';
import GetAppOutlined from '@mui/icons-material/GetAppOutlined';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import styled from 'styled-components';
import { CardContent, TextareaAutosize, Tooltip } from '@mui/material';
import KeyboardArrowDownOutlined from '@mui/icons-material/KeyboardArrowDownOutlined';
import Grid from '@mui/material/Grid';
import Clear from '@mui/icons-material/Clear';
import { withStyles } from '@mui/styles';
import { CheckCircle, CopyAllOutlined, Refresh, Sync } from '@mui/icons-material';

const EmpasizeText = styled(Typography)`
  font-weight: 700;
`;
const SemiEmpasizeText = styled(Typography)`
  font-weight: 400;
`;
export const CloseIcon = (props) => (
  <IconButton {...props} size="large">
    <Clear style={{ fontSize: '1rem' }} />
  </IconButton>
);
export const DownloadIcon = (props) => (
  <IconButton {...props} size="large">
    <GetAppOutlined style={{ color: '#5A50E2', fontSize: '1rem' }} />
  </IconButton>
);
export const ChevronDownIcon = (props) => (
  <IconButton {...props} size="large">
    <KeyboardArrowDownOutlined style={{ fontSize: '1rem' }} />
  </IconButton>
);
export const CopyIcon = (props) => (
  <IconButton size="small" {...props}>
    <FileCopyOutlined style={{ color: '#5A50E2', fontSize: '1rem' }} />
  </IconButton>
);
export const CopyWithFeedbackIcon = (props) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText(props.value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    if (props?.onClick) props.onClick();
  };
  return (
    <Tooltip title={copied ? 'Copied' : 'Copy'}>
      {copied ? (
        <CheckCircle sx={{ cursor: 'pointer', fontSize: '18px', ...props.sx }} color="success" />
      ) : (
        <CopyAllOutlined
          {...props}
          sx={(theme) => ({ color: theme.palette.info.main, fontSize: '18px', cursor: 'pointer', ...props.sx })}
          onClick={handleCopy}
        />
      )}
    </Tooltip>
  );
};
export const RefreshIcon = (props) => (
  <IconButton size="small" {...props}>
    <Refresh style={{ color: '#5A50E2', fontSize: '1rem' }} />
  </IconButton>
);
export const SyncIcon = (props) => (
  <IconButton size="small" {...props}>
    <Sync style={{ color: '#5A50E2', fontSize: '1.2rem', fontWeight: 'bold', transform: 'rotate(90deg)' }} />
  </IconButton>
);
export const Empasize = ({ children, ...rest }) => {
  return <EmpasizeText {...rest}>{children}</EmpasizeText>;
};
export const SemiEmpasize = ({ children, ...rest }) => {
  return <SemiEmpasizeText {...rest}>{children}</SemiEmpasizeText>;
};
export const CenteredRow = ({ children, spacing = 2, ...rest }) => {
  return (
    <Grid {...rest} container alignItems="center" spacing={spacing}>
      {children}
    </Grid>
  );
};
export const ColumnGrid = ({ children, spacing = 2, ...rest }) => {
  return (
    <Grid {...rest} container direction="column" spacing={spacing}>
      {children}
    </Grid>
  );
};
export const TableFilterChip = withStyles({
  root: {
    background: 'white',
    padding: '5px',
  },
})(CardContent);

export const CustomTextArea = styled(TextareaAutosize)`
  width: 100%;
  min-height: 100px;
  border-radius: 5px;
  border: 1px solid --var(--locad-custom-textarea-border);
  resize: none;
  font-family: inherit;
  background: var(--colors-data-table-head);
  padding: 5px 12px 0 12px;
`;
